import React from "react";
import * as Scrivito from "scrivito";
import { LeftSidebarPortal } from "../LeftSidebar/LeftSidebarPortal";
import { ProductConfiguratorLeftSidebar } from "./components/LeftSideBar/ProductConfiguratorLeftSidebar";
import { ProductConfiguratorHeader } from "./components/Header/ProductConfiguratorHeader";
import { XCircleLoader } from "components";
import {
  useIsProductLoading,
  useIsSwitchingProduct,
  useProductOutput,
} from "stores/product";

export const ProductConfiguratorLayout = Scrivito.connect(
  ({ children }: { children: React.ReactNode }) => {
    const isLoading = useIsProductLoading();
    const isSwitchingProduct = useIsSwitchingProduct();
    const productOutput = useProductOutput();
    return (
      <div
        data-testid="product-configurator-layout"
        className="d-flex flex-column min-h-0 overflow-hidden"
      >
        <LeftSidebarPortal>
          <ProductConfiguratorLeftSidebar />
        </LeftSidebarPortal>
        {(isLoading && !productOutput) || (isLoading && isSwitchingProduct) ? (
          <div className="d-flex flex-column justify-content-center align-items-center h-full">
            <XCircleLoader />
          </div>
        ) : (
          <div className={"px-7 py-4 d-flex flex-column max-h-full pb-1"}>
            <div className="flex-shrink-0">
              <ProductConfiguratorHeader />
            </div>
            <div
              className="w-100 overflow-y-auto d-flex flex-column"
              style={{ flex: "1 1 0%", minHeight: 0 }}
            >
              {children}
            </div>
          </div>
        )}
      </div>
    );
  },
);
